import React from 'react'

const arr= [
  {
    'id': 1,
    'name': 'Phone',
    'image': 'iphonexr.PNG',
  },  {
    'id': 2,
    'name': 'JBL',
    'image': 'iphonex.PNG',
  },  {
    'id': 3,
    'name': 'Watch',
    'image': 'black.webp',
  },  {
    'id': 4,
    'name': 'Iphone6',
    'image': 'iphone6.PNG',
  },  {
    'id': 5,
    'name': 'HeadPhone',
    'image': 'headphone.png',
  },  {
    'id': 6,
    'name': 'laptop',
    'image': 'laptop.png',
  },
]


const Singlecategories = () => {

    const singlecategories=()=>{
       return arr.map(data=>{
 return <div id='singlecategories-wrapper'>
     <img src={`/asset/${data.image}`} alt="" srcset="" />
     <h3>{data.name}</h3>
     </div>
        })
    }
  return (
    <>
    <div id='singlecategories-container'>
        {singlecategories()}
    </div>
    </>
   
  )
}

export default Singlecategories